<div class="container">
  <img class="background" [src]="cdnBase + '/rain-background.png'" alt="" />
  <div class="icon-container">
    <app-icon class="icon-icon" icon="rain" />
  </div>
  <div class="message">
    <span class="message-title">live rain</span>
    <span class="message-content">rain pool</span>
  </div>
  <div class="end-col">
    @if (canTip()) {
      <button class="button-tip" type="button" (click)="tipRainModal()">Tip</button>
    }
    <button class="button-rain" type="button" [disabled]="!canJoin()" (click)="chatService.openRainCaptcha()">
      <span class="button-rain-inside button" [ngClass]="{ gray: !chatService.rain.joined, yellow: chatService.rain.joined }">
        <app-icon class="icon" icon="coin" />
        <app-currency class="currency" [value]="5" [size]="14"></app-currency>
      </span>
      <span class="title">
        {{ joinLabel() }}
      </span>
    </button>
  </div>
  <div class="timer-bar">
    <div class="timer-bar-inner" [style.transform]="'scaleX(' + chatService.rain.timeleft / (chatService.rain.live ? 300 : 3600) + ')'"></div>
  </div>
</div>
